// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"02972b50","239":"fe726e06","667":"009d6073"}[chunkId] + ".chunk.js";
};